import styled from 'styled-components';

export const CategoryFilterSection = styled.section`
  padding: ${(props) =>
    props.padding ? '30px 7.5%' : props.noPadding ? '0' : '0 7.5%'};
  margin: 46px 0;
  background-image: none;
  background-position: top;
  background-position-x: 2px;
  background-position-y: -10px;
  background-size: 100% auto;
  background-repeat: no-repeat;
  @media (max-width: 720px) {
    margin: ${(props) => (props.noMwebPadding ? '0' : '30px 0 0')};
    padding: ${(props) => (props.padding ? '20px 0' : '0 ')};
    background-image: url(${(props) => props.bg});
  }
`;

export const CategoryFilterStyled = styled.ul`
  display: flex;
  align-items: center;
  overflow-y: scroll;
  width: 100%;
  margin: 16px 0;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const CategoryTitle = styled.h2`
  font-size: clamp(18px, 2vw, 24px);
  color: hsl(0deg, 0%, 0%, 87%);
  padding: 0 12px;
  padding: 0 12px;
  text-align: center;
  letter-spacing: 5px;
  text-transform: uppercase;
`;

export const FilterList = styled.li`
  border-radius: 8vmax;
  background: #fff;
  border: 1px solid hsl(0deg, 0%, 0%, 10%);
  padding: 6px 12px;
  width: max-content;
  flex-shrink: 0;
  margin: 0 8px;
  font-size: clamp(12px, 2vw, 14px);
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 80%);
  &:hover {
    background: #f1f1f1;
  }

  @media (min-width: 720px) {
    cursor: pointer;
  }

  &.active {
    background: #63b0a8;
    color: #fff;
    transform: scale(1.04);
  }
`;

export const CategoryCard = styled.div`
  flex-basis: 16%;
  background: #fff;
  box-shadow: none;
  border-radius: 6px;
  text-align: center;
  padding: 6px 4px;
  margin: 10px 4% 0 0;
  transition:
    transform 0.3s cubic-bezier(0.155, 1.105, 0.295, 1.12) 0s,
    box-shadow 0.3s ease 0s;
  &.lowOpacity {
    opacity: 0.4;
  }
  @media (max-width: 720px) {
    flex-basis: 23%;
    margin: 0;
    height: 118px;
    box-shadow: 0 1px 2px 0 rgb(0 0 0 / 16%);
  }

  &:hover {
    transform: scale(1.02);
  }
`;

export const CategoryProdImage = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  padding-top: 100%;
  @media (max-width: 720px) {
    width: 62px;
    height: 62px;
    padding-top: initial;
  }
`;

export const CategoryProdName = styled.span`
  font-size: clamp(11px, 2vw, 15px);
  padding: 4px 0 2px;
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 87%);
  display: block;
`;
